import "./SuccessScreen.css";
const SuccessScreen = () => {
  return (
    <div className="main">
      <div className="text-container error0">
        <div className="text"></div>
        <div className="text">MESSAGE SENT MESSAGE SENT</div>
      </div>
      <div className="text-container error1">
        <div className="text">Thank you ~ Thank you</div>
        <div className="text">Thank you ~ Thank you</div>
      </div>
      <div className="text-container error2">
        <div className="text"></div>
        <div className="text">アタイで Atayde アタイで</div>
      </div>
      <div className="text-container error3">
        <div className="text">
          <span> </span>Thank you ~ Thank you ~
        </div>
        <div className="text">
          <span> </span>Thank you ~ Thank you ~
        </div>
      </div>
      <div className="text-container error4">
        <div className="text"></div>
        <div className="text">MESSAGE SENT MESSAGE SENT</div>
      </div>
    </div>
  );
};

export default SuccessScreen;
